/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSidebarBlurbs_vipUserRelationship$ref = any;
export type PdpRespContainer_vipUserRelationship$ref = any;
export type PdpRespContainer_vipUserRelationship = {
    readonly " $fragmentRefs": PdpRespSidebarBlurbs_vipUserRelationship$ref;
    readonly " $refType": PdpRespContainer_vipUserRelationship$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespContainer_vipUserRelationship",
    "type": "UserRelationship",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarBlurbs_vipUserRelationship",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b3496aec22adf532daa3156b8e973f56';
export default node;
